import { useContext } from "react";
import { Link, useParams } from "react-router-dom";

import { EuserContext } from "../data/providers/EuserProvider";

function ManageButtons() {
  const { tournamentId } = useParams();

  const euserContext = useContext(EuserContext);
  const { euser, euserIsAdmin, euserIsEditor, signOut, euserIsVolunteer } =
    euserContext;

  const signOutTrigger = () => {
    signOut();
    // no need to navigate away. they are on the home page
  };

  return (
    <div>
      {/* If there is an euser in the system */}
      {euser ? (
        <div className="btn-row">
          <Link
            to={`/tournaments/${tournamentId}/register`}
            className="btn btn-blue"
          >
            Register
          </Link>

          {euserIsAdmin() || euserIsEditor() ? (
            <Link
              to={`/tournaments/${tournamentId}/edit`}
              className="btn btn-green"
            >
              Manage
            </Link>
          ) : euserIsVolunteer() ? (
            <Link
              to={`/tournaments/${tournamentId}/admin/check-in`}
              className="btn btn-green"
            >
              Manage
            </Link>
          ) : null}

          <Link to={`/account/reservations`} className="btn btn-green">
            Tickets
          </Link>

          <Link to={`/account/edit`} className="btn btn-green">
            Account
          </Link>

          <button className="btn btn-white" onClick={signOutTrigger}>
            Sign Out
          </button>
        </div>
      ) : (
        // If there is no euser
        <div className="btn-row">
          <Link to={`/account/signin`} className="btn btn-blue">
            Sign In
          </Link>
        </div>
      )}
    </div>
  );
}

export default ManageButtons;
